import React from 'react';

const ProfileContext = React.createContext({});

const ProfileContextProvider = ProfileContext.Provider;
const ProfileContextConsumer = ProfileContext.Consumer;

export { ProfileContextProvider, ProfileContextConsumer };
